// Libraries
import React, {FormEvent, FunctionComponent} from 'react';
import {Input, InputNumber} from 'antd';
import PropTypes from 'prop-types';


type InputComponentType = {
  readOnly?: boolean;
  disabled?: boolean;
  placeHolder?: string;
  type?: string;
  prefix?: string;
  className?: string;
  value?: string | number;
  title?: string;
  onChange?: (e: FormEvent<HTMLInputElement> | FormEvent<HTMLTextAreaElement>) => void;
};
const InputComponent: FunctionComponent<InputComponentType> = (
  {
    readOnly, disabled, placeHolder, type, prefix,
    className, value, title, onChange,
  }) => {
  const builder = () => {
    let input;

    switch (type){
      case 'textarea':
        input = <Input.TextArea placeholder={placeHolder} autoSize={{ minRows: 2, maxRows: 3 }} value={value}
                                className={'appearance-none block w-full px-3 py-2 border border-grey-dkt-300 rounded-md shadow-sm ' +
                                  'placeholder-grey-dkt-400 focus:outline-none focus:ring-orange-dkt-400 focus:border-orange-dkt-400 sm:text-sm ' +
                                  className
                                }
                                onChange={(e) => onChange ? onChange(e) : null} />
        break;
      case 'currency':
        input = <InputNumber placeholder={placeHolder} value={value} addonBefore={prefix}
                             className={'appearance-none w-full px-0 py-0 border border-grey-dkt-300 rounded-md shadow-sm ' +
                               'placeholder-grey-dkt-400 focus:outline-none focus:ring-orange-dkt-400 focus:border-orange-dkt-400 sm:text-sm ' +
                               '[&>div]:h-9 [&>div>div>div>input]:h-9 [&>div>div]:h-9 [&>div>div]:border-0 [&>div>.ant-input-number]:border-l [&>div>.ant-input-number]:rounded-l-none' +
                               className
                             }
                             onChange={(e: any) => onChange ? onChange(e) : null} />
        break;
      default:
        input = <Input readOnly={readOnly} disabled={disabled} placeholder={placeHolder} prefix={prefix}
                       type={type} value={value} title={title}
                       className={'appearance-none block w-full px-3 py-2 border border-grey-dkt-300 rounded-md shadow-sm ' +
                         'placeholder-grey-dkt-400 focus:outline-none focus:ring-orange-dkt-400 focus:border-orange-dkt-400 sm:text-sm ' +
                         className
                       }
                       onChange={(e) => onChange ? onChange(e) : null} />
        break;
    }

    return input;
  }

  return (
    builder()
  );
}

InputComponent.propTypes = {
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  placeHolder: PropTypes.string,
  type: PropTypes.string,
  prefix: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  title: PropTypes.string,
  onChange: PropTypes.func,
};
InputComponent.defaultProps = {
  readOnly: false,
  disabled: false,
  placeHolder: '',
  type: 'text',
  prefix: '',
  value: '',
  title: '',
  className: '',
  onChange: () => {
    return null;
  }
};

export default InputComponent;